import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { loaiChungChiChungNhanApi } from "../../../api/category/loaiChungChiChungNhanApi";
import { rootActions } from "../../actions/rootActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { eLoaiChungChiChungNhanActionIds, ILoaiChungChiChungNhanActionTypes } from "../../action-types/category/ILoaiChungChiChungNhanActions";
import { IDmLoaiChungChiChungNhan } from "../../../model/response/category/IDmLoaiChungChiChungNhan";

const mainAction = rootActions.category.loaiChungChiChungNhan;

export function* loaiChungChiChungNhanSaga(): any {
    yield takeLatest(eLoaiChungChiChungNhanActionIds.LOAD_START, loadWorker);
    yield takeEvery(eLoaiChungChiChungNhanActionIds.SAVE_START, saveWorker);
    yield takeEvery(eLoaiChungChiChungNhanActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
    const res = yield call(loaiChungChiChungNhanApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Loại chứng chỉ chứng nhận"));
    }
}

function* saveWorker(action: ILoaiChungChiChungNhanActionTypes): any {
    let res;
    const payload = action.payload as IDmLoaiChungChiChungNhan;
    if (payload.id > 0) {
        res = yield call(loaiChungChiChungNhanApi.Update, payload.id, payload);
    } else {
        res = yield call(loaiChungChiChungNhanApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu Loại chứng chỉ chứng nhận"));
    }
}

function* deleteWorker(action: ILoaiChungChiChungNhanActionTypes): any {
    const id = action.payload as number;
    const res = yield call(loaiChungChiChungNhanApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa Loại chứng chỉ chứng nhận"));
    }
}